import { TextSelection, NodeSelection, EditorState, Transaction } from "prosemirror-state";
import { canSplit } from "prosemirror-transform";
import { Fragment, NodeType } from "prosemirror-model";

/**
 * Like `splitBlock` from prosemirror-commands, but tries to clone even if at the end of a block
 */
export function splitBlockAlwaysTryClone(state: EditorState, dispatch?: (tx: Transaction) => void) {
	const { $from, $to } = state.selection;

	if (state.selection instanceof NodeSelection && state.selection.node.isBlock) {
		if (!$from.parentOffset || !canSplit(state.doc, $from.pos)) return false;
		if (dispatch) dispatch(state.tr.split($from.pos).scrollIntoView());
		return true;
	}

	if (!$from.parent.isBlock) return false;

	if (dispatch) {
		const atEnd = $to.parentOffset === $to.parent.content.size;
		const tr = state.tr;
		if (state.selection instanceof TextSelection) tr.deleteSelection();
		const deflt =
			$from.depth === 0
				? undefined
				: $from.node(-1).contentMatchAt($from.indexAfter(-1)).defaultType;

		// first, see if we can split while cloning the type of the containing node
		let types: ({ type: NodeType } | null)[] | undefined;
		let can = canSplit(tr.doc, tr.mapping.map($from.pos), 1, types);

		// if that's not possible, then try again but with the newly inserted node being just a default node (here, a paragraph)
		if (!can) {
			types = (deflt && [{ type: deflt }]) ?? undefined;
			if (types && canSplit(tr.doc, tr.mapping.map($from.pos), 1, types)) {
				can = true;
			}
		}

		if (can) {
			tr.split(tr.mapping.map($from.pos), 1, types);
			if (
				!atEnd &&
				!$from.parentOffset &&
				$from.parent.type !== deflt &&
				$from
					.node(-1)
					.canReplace(
						$from.index(-1),
						$from.indexAfter(-1),
						Fragment.from(deflt!.create())
					)
			)
				tr.setNodeMarkup(tr.mapping.map($from.before()), deflt);
		}
		dispatch(tr.scrollIntoView());
	}
	return true;
}
